import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import Container from '/@/components/container';
import Message from '/@/components/message';
import { _ } from '/@/locale';

import BrandDisplay from '/@/v3/components/brand-display';
// V3 components
import styles from './styles.module.css';

@autobind
export default class BrandSelection extends Component {
    static propTypes = {
        title: PropTypes.string,
        subtitle: PropTypes.string,
        brands: PropTypes.array.isRequired,
        onClick: PropTypes.func.isRequired,
        isLogin: PropTypes.bool,
    };

    static defaultProps = {
        isLogin: false,
    };

    render() {
        const { brands, onClick, isLogin } = this.props;
        return (
            <Container
                className={isLogin && styles.login}
                classNameRoot={classNames(styles.containerClass, isLogin && styles.loginContainer)}
            >
                <div className={styles.root}>
                    <div className={isLogin ? styles.loginContent : styles.content}>
                        <div
                            className={
                                isLogin
                                    ? this.props.brands.length >= 3
                                        ? styles.loginBrandsXl
                                        : styles.loginBrands
                                    : classNames(styles.brands, this.props.brands.length >= 4 && styles.large)
                            }
                        >
                            {brands
                                .sort((a, b) => a.order - b.order)
                                .map((brand) => (
                                    <Fragment key={brand.id}>
                                        <div className={styles.brandWrapper}>
                                            <div className={!isLogin && styles.brand} key={brand.id}>
                                                <BrandDisplay
                                                    withTheme
                                                    withImage
                                                    brand={brand}
                                                    onClick={() => onClick(brand.type, brand.slug, brand.name)}
                                                    isLogin={isLogin}
                                                    button={!isLogin}
                                                />
                                            </div>
                                        </div>
                                    </Fragment>
                                ))}
                        </div>

                        {brands.length === 0 && (
                            <Message type='warning' appearance='fill' showIcon>
                                {_('No hay marcas disponibles.')}
                            </Message>
                        )}
                    </div>
                </div>
            </Container>
        );
    }
}
